function ImprvCoinIcon({ size = 16, className = '' }: { size?: number; className?: string }) {
  return (
    <div className={'inline-flex shrink-0 items-center ' + className}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 16'
        fill='none'
      >
        <circle cx='8' cy='8' r='7.5' fill='#FFC975' stroke='#A1742F' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          transform='translate(4 4.5)'
          d='M4.87772 6.47079V4.3299C4.87772 4.25773 4.94472 4.1976 5.02513 4.1976H7.39698C7.47739 4.1976 7.54439 4.25773 7.54439 4.3299V6.47079C7.54439 6.54296 7.47739 6.60309 7.39698 6.60309H5.02513C4.94472 6.60309 4.87772 6.54296 4.87772 6.47079ZM4.43551 6.47079C4.43551 6.75945 4.70352 7 5.02513 7H7.39698C7.71859 7 7.9866 6.75945 7.9866 6.47079V4.3299C7.9866 4.04124 7.71859 3.80069 7.39698 3.80069H5.02513C4.70352 3.80069 4.43551 4.04124 4.43551 4.3299V6.47079ZM6.21775 0.396906C6.95477 0.396906 7.55779 0.938143 7.55779 1.59966C7.55779 2.26117 6.95477 2.80241 6.21775 2.80241C5.48074 2.80241 4.87772 2.26117 4.87772 1.59966C4.87772 0.938143 5.48074 0.396906 6.21775 0.396906ZM8 1.59966C8 0.721648 7.19598 0 6.21775 0C5.23953 0 4.43551 0.721648 4.43551 1.59966C4.43551 2.47766 5.23953 3.19931 6.21775 3.19931C7.19598 3.19931 8 2.47766 8 1.59966ZM1.71524 3.86082C2.66667 3.86082 3.43049 4.54639 3.43049 5.40035C3.43049 6.2543 2.66667 6.93986 1.71524 6.93986C0.76382 6.93986 0 6.2543 0 5.40035C0 4.54639 0.76382 3.86082 1.71524 3.86082ZM0.0134012 2.68213C0.0134012 2.94674 0.254606 3.1512 0.536013 3.1512H2.90787C3.20268 3.1512 3.43049 2.93471 3.43049 2.68213V0.541237C3.43049 0.276632 3.18928 0.072162 2.90787 0.072162H0.536013C0.241206 0.072162 0.0134012 0.28866 0.0134012 0.541237V2.68213Z'
          fill='#A1742F'
        />
      </svg>
    </div>
  );
}

export default ImprvCoinIcon;
